import { createGlobalStyle, css } from 'styled-components';
import { currentContentConfig } from 'utils/handleCurrentContentConfig';

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Gibson Bold';
    src: url('/fonts/Gibson_v4-Bold.otf') format('opentype');
  }

  ${({ isLogin }) =>
    isLogin &&
    css`
      html {
        background: url(${currentContentConfig.background}) no-repeat fixed;
        background-size: cover;
        @media (min-width: 1025px) {
          background-position: center;
        }
      }
    `}
`;
